import { Translate } from "components/common/Translate/Translate";
import { TextBox } from "store/features/memeGenerator/types";
import type { Mode as ModeType } from "../types";

export interface ModeProps {
    textBox: TextBox;
    mode: ModeType;
    setMode: (mode: ModeType) => void;
}

export const Mode = ({ textBox, mode, setMode }: ModeProps) => {
    return (
        <div className="px-8 flex gap-8 text-sm border-b border-b-[#DCDDDF] dark:border-b-darkSurface-400">
            <button className="relative flex flex-col items-center gap-2 py-8 h-full" onClick={() => setMode("text")}>
                <div
                    className={`w-[44px] h-[44px] rounded-lg border ${
                        mode === "text" ? `border-4 border-irBlue-200` : ""
                    }`}
                    style={{ backgroundColor: textBox.fontColor }}
                />
                <div
                    className={`${
                        mode === "text" ? `text-irBlue-200 dark:text-darkPrimary-100` : `text-black dark:text-white`
                    } capitalize`}
                >
                    <Translate keyName="text" />
                </div>
                {/* triangle */}
                {mode === "text" && (
                    <div className="absolute bottom-0 left-0 right-0 flex items-center justify-center">
                        <div className="w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-[12px] border-b-[#DCDDDF] dark:border-b-darkSurface-400"></div>
                    </div>
                )}
            </button>
            {textBox.outline?.isActive && (
                <button className="relative flex flex-col items-center gap-2 py-8" onClick={() => setMode("outline")}>
                    <div
                        className={`w-[44px] h-[44px] rounded-lg border ${
                            mode === "outline" ? `border-4 border-irBlue-200` : ""
                        }`}
                        style={{ backgroundColor: textBox.outline.color }}
                    />
                    <div
                        className={`${
                            mode === "outline"
                                ? `text-irBlue-200 dark:text-darkPrimary-100`
                                : `text-black dark:text-white`
                        } capitalize`}
                    >
                        <Translate keyName="outline" />
                    </div>
                    {/* triangle */}
                    {mode === "outline" && (
                        <div className="absolute bottom-0 left-0 right-0 flex items-center justify-center">
                            <div className="w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-[12px] border-b-[#DCDDDF]"></div>
                        </div>
                    )}
                </button>
            )}
            {textBox.shadow?.isActive && (
                <button className="relative flex flex-col items-center gap-2 py-8" onClick={() => setMode("shadow")}>
                    <div
                        className={`bg-white w-[44px] h-[44px] rounded-lg border ${
                            mode === "shadow" ? `border-4 border-irBlue-200` : ""
                        }`}
                        style={{ backgroundColor: textBox.shadow.color }}
                    />
                    <div
                        className={`${
                            mode === "outline"
                                ? `text-irBlue-200 dark:text-darkPrimary-100`
                                : `text-black dark:text-white`
                        } capitalize`}
                    >
                        <Translate keyName="shadow" />
                    </div>
                    {/* triangle */}
                    {mode === "shadow" && (
                        <div className="absolute bottom-0 left-0 right-0 flex items-center justify-center">
                            <div className="w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-[12px] border-b-[#DCDDDF]"></div>
                        </div>
                    )}
                </button>
            )}
        </div>
    );
};
